module.exports = __webpack_public_path__ + "img/close.7432e657.svg";